// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

/* 路由 */
import router from "./router";

/* axios */
import axios from "./api";
import api from "./api/api";
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import "swiper/dist/css/swiper.min.css";

/* 重置样式 */
import "./assets/css/reset.min.css";

/* jquery */
import "jquery";

/* bootstarp */
import "./assets/css/bootstrap.min.css";
import "./assets/js/bootstrap.min";

/* 图标 */
import "font-awesome/css/font-awesome.min.css";
/* animate.css */
import "animate.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

/* 全局样式：wh */
import "./assets/css/global.css";

/* 头部组件 */
import Header from "./components/Header";
Vue.component(Header.name, Header);

/* 尾部组件 */
import Footer from "./components/Footer";
Vue.component(Footer.name, Footer);

/* 回到顶部 */
import GoTop from "./components/GoTop";
Vue.component(GoTop.name, GoTop);

import { setWatermark } from "@/utils/watermark";
// 全局挂载水印方法
Vue.prototype.$setWatermark = setWatermark;

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if(to.redirectedFrom  && to.redirectedFrom.slice(1, 8) === 'section'){
    next({ path: "/servicedetail" })
  } else {
    next()
  }
})

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js